import React from 'react';

const Footer = () => (
    <nav className="navbar navbar-light bg-warning footer">
    <p className="navbar-brand">React Clicky Game</p>
    </nav>
)

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js